import CryptoJS from 'crypto-js'
import {sessionStorageTool, store} from '@/common'
import platform from '@/config/platform'

let _websocketUrl = platform.url.nettyServer + '/ws/saaf'
let webSocket = {}
webSocket.userInfo = {}


let createUrl = (userInfo, appInfo) => {
	let _appId = CryptoJS.enc.Utf8.parse(appInfo.appId)
	let _params = JSON.stringify({
		"userId": userInfo.userId,
		"userName": userInfo.userFullName,
		"appId": CryptoJS.enc.Base64.stringify(_appId),
		"authorizationCode": userInfo.authorizationCode
	})
	let _utf8Val = CryptoJS.enc.Utf8.parse(_params)
	let _base64Url = encodeURIComponent(CryptoJS.enc.Base64.stringify(_utf8Val))
	return `${_websocketUrl}/${_base64Url}`;
}

let heartbeat =  {
	timeout: 60000, //60秒
	timeoutObj: null,
	reset: function(){
		clearTimeout(this.timeoutObj);
		return this;
	},
	start: function(){
		this.timeoutObj = setTimeout(function(){
			//这里发送一个心跳，后端收到后，返回一个心跳消息，
			//onmessage拿到返回的心跳就说明连接正常
			let _receiptUserIdList = []
			_receiptUserIdList.push(webSocket.userInfo.userId)
			let _msg = {"receiptUserIdList": _receiptUserIdList, "data": "heartbeat"}
			webSocket.send(JSON.stringify(_msg));
		}, this.timeout)
	}
}

// 回调函数集, 用于注册不用页页的回调函数
webSocket.onMessageCallback = {}
webSocket.openCallback = {}
webSocket.closeCallback = {}

/**后端返回错误信息*/
const doErrorCallback = (imRoomBean) => {
	throw Error(imRoomBean.imRoomMsgBean.msg);
}

webSocket.init = (userInfo, appInfo, messageCallback, openCallback, closeCallback) => {
    window.saafWebSocket = webSocket;
	let _socket = Object
	if(window.WebSocket){
		_socket = new WebSocket(createUrl(userInfo, appInfo));
		window.socket = _socket
		let _appId = CryptoJS.enc.Utf8.parse(appInfo.appId)
		_socket.appId = CryptoJS.enc.Base64.stringify(_appId)

		_socket.onmessage = function(event){
			//console.log(event)
			let _responseData = JSON.parse(event.data)
			//console.log(_responseData)
			if (_responseData.msgType === "ERROR") {
				doErrorCallback(JSON.parse(_responseData.data))
				return
			} else if (_responseData.msgType === "CONN_CHANNEL") {
				_socket.channelId = _responseData.channelId
				return;
			}
			let _data = JSON.parse(_responseData.data)
			_data.msgType = _responseData.msgType
			/*if (typeof webSocket.onMessageCallback[_data.pageId] === "function") {
				webSocket.onMessageCallback[_data.pageId](_data);
			}*/
      // 检查是否有自定义的回调监听，有则调用自定义回调
      if (!!_responseData.listenerCallbackEvent && !!webSocket.onMessageCallback[_responseData.listenerCallbackEvent]
          && typeof webSocket.onMessageCallback[_responseData.listenerCallbackEvent] === "function") {
          webSocket.onMessageCallback[_responseData.listenerCallbackEvent](_data)
        // ADD BY LIZHEN 2024-04-01收到消息时，再调一次主界面，用于刷新聊天室状态
        if ("sendMsgCallbackEvent" === _responseData.listenerCallbackEvent) {
          messageCallback(_data)
        }

      } else if (typeof messageCallback === "function") {
				messageCallback(_data);
			}
		};

		_socket.onopen = function(event){
			if (typeof openCallback === "function") {
				openCallback(event)
			}
		};

		_socket.onclose = function(event){
			if (typeof closeCallback === "function") {
				closeCallback(event)
			}
		};
	} else {
		alert("您的浏览器不支持WebSocket协议！");
	}
}

webSocket.send = (msgObj) => {
	if(!window.WebSocket){
		return;
	}
	if(window.socket.readyState == WebSocket.OPEN){
		//通过socket 发送消息
		msgObj.appId = window.socket.appId
		window.socket.send(JSON.stringify(msgObj))
	} else {
		alert("WebSocket 连接没有建立成功！");
	}
}

/**
 * 添加回调监听方法
 * @param listenerCode
 * @param listenerEvent
 */
webSocket.addListenerCallback = (listenerCode, listenerEvent) => {
    webSocket.onMessageCallback[listenerCode] = listenerEvent
}

/**
 * 删除回调监听方法
 * @param listenerCode
 * @param listenerEvent
 */
webSocket.removeListenerCallback = (listenerCode) => {
    delete webSocket.onMessageCallback[listenerCode]
}



export default webSocket



// WEBPACK FOOTER //
// ./src/utils/WebSocket.js